import { Typography } from "antd"
import styles from './SheetCloseButton.module.css'

const SheetCloseButton = ({ onClick }: { onClick: () => void }) => {
    const {Text} = Typography
  return (
    <div className={styles.closeIconContainer} onClick={onClick}>
      <Text className={styles.close}
      >
        X
      </Text>
  </div>

  )
}

export default SheetCloseButton